<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>{{tituloCrud}}</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioProcedimentoConsulta" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-9 col-md-9 col-sm-8 col-12">
                            <mat-label>Nome</mat-label>
                            <input matInput value="Nome" class="form-control" id="nome" required trim="blur" name="nome"
                                formControlName="nome" maxlength="60" upperCase>
                            <mat-error *ngIf="formularioProcedimentoConsulta.controls.nome.hasError('required')">
                                O campo Nome é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioProcedimentoConsulta.controls.nome.hasError('minlength')">
                                O campo Nome precisa conter mais do que 4 caracteres.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field floatPlaceholder="always" class="form-group col-lg-3 col-md-3 col-sm-4 col-12"
                            style="padding-top: 2px;">
                            <input matInput style="display: none">
                            <mat-checkbox id="disponivel" formControlName="disponivel">Disponível</mat-checkbox>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-9 col-md-8 col-sm-12 col-12">
                            <mat-label>Apelido</mat-label>
                            <input matInput value="Apelido" class="form-control" id="apelido" required trim="blur"
                                name="apelido" formControlName="apelido" maxlength="12" upperCase>
                            <mat-error *ngIf="formularioProcedimentoConsulta.controls.apelido.hasError('required')">
                                O campo Apelido é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioProcedimentoConsulta.controls.apelido.hasError('minlength')">
                                O campo Apelido precisa conter mais do que 2 caracteres.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-3 col-md-4 col-sm-12 col-12">
                            <mat-label>Tipo Agendamento</mat-label>
                            <mat-select value="Tipo Agendamento" formControlName="tipoAgendamento"
                                name="tipoAgendamento" id="tipoAgendamento" required>
                                <mat-option *ngFor="let tipoAgendamento of listaTipoAgendamento"
                                    [value]="tipoAgendamento.codigo">
                                    {{tipoAgendamento.descricao}}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="formularioProcedimentoConsulta.controls.tipoAgendamento.hasError('required')">
                                O campo Tipo Agendamento é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-9 col-md-9 col-sm-8 c  ol-12">
                            <mat-label>Especialidade</mat-label>
                            <mat-select value="Especialidade" formControlName="especialidade" name="especialidade"
                                id="especialidade" required>
                                <mat-option *ngFor="let especialidade of listaEspecialidades" [value]="especialidade">
                                    {{especialidade.nome}}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="formularioProcedimentoConsulta.controls.especialidade.hasError('required')">
                                O campo Especialidade é obrigatório.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-3 col-md-3 col-sm-4 col-12">
                            <mat-label>Valor</mat-label>
                            <input matInput value="Valor" class="form-control" id="valor" name="valor"
                                formControlName="valor" maxlength="8" trim="blur" upperCase currencyMask
                                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
                            <mat-error *ngIf="formularioProcedimentoConsulta.controls.valor.hasError('required')">
                                O campo Valor é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field style="margin-top: 6.5px;"
                            class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
                            <mat-label>Observação</mat-label>
                            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                cdkAutosizeMinRows="2" cdkAutosizeMaxRows="8" formControlName="observacao"
                                name="observacao" id="observacao" maxlength="120" upperCase></textarea>
                        </mat-form-field>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10" *ngIf="!isInfo">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioProcedimentoConsulta.valid">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <botao-voltar></botao-voltar>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>